import { render, staticRenderFns } from "./listagemSimple.vue?vue&type=template&id=63c3047b&scoped=true&"
import script from "./listagemSimple.vue?vue&type=script&lang=js&"
export * from "./listagemSimple.vue?vue&type=script&lang=js&"
import style0 from "./listagemSimple.vue?vue&type=style&index=0&id=63c3047b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c3047b",
  null
  
)

export default component.exports